import { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';
import { useResponsive } from '../../contexts/ResponsiveContext';

interface LogoLinkProps {
    mfg: string;
    image: string;
    href: string;
    mfgText: string;
}

const LogoLink: FunctionComponent<LogoLinkProps> = (LogoLinkProps) => {
    const handleClick = () => {
        window.open(LogoLinkProps.href, '_blank');
    };
    const { isScreenLg, isScreenMd, isScreenXs } = useResponsive();

    return (
        <Box
            data-testid={`${LogoLinkProps.mfg}_main_container`}
            sx={{
                height: isScreenLg || isScreenXs ? '250px' : isScreenMd ? '200px' : '300px',
                width: isScreenLg || isScreenXs ? '250px' : isScreenMd ? '200px' : '300px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '0.8px solid rgba(119, 119, 119, 0.5)',
                borderRadius: '3px',
                transition: 'box-shadow 0.3s ease-in-out', // 過渡效果
                '&:hover': {
                    boxShadow: '0px 2px 14px 0px #8080804D', // 使用 Figma 的陰影效果
                },
                cursor: 'pointer',
            }}
            onClick={handleClick}
        >
            <Box
                data-testid={`${LogoLinkProps.mfg}_content_container`}
                sx={{
                    height: '140px',
                    width: '17rem',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    gap: '3rem',
                }}
            >
                <Box
                    data-testid={`${LogoLinkProps.mfg}_image_container`}
                    sx={{
                        height: '55px',
                        width: '170px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <img
                        src={LogoLinkProps.image}
                        alt={`${LogoLinkProps.mfg} logo`}
                        style={{
                            height: isScreenMd ? '80%' : '100%',
                            width: isScreenMd ? '80%' : '100%',
                        }}
                    />
                </Box>
                <Box
                    data-testid={`${LogoLinkProps.mfg}_text_container`}
                    sx={{ height: '26px', width: '100%' }}
                >
                    <Typography
                        sx={{
                            fontSize: isScreenMd || isScreenXs ? '22px' : '32px',
                            fontWeight: 500,
                            lineHeight: '26px',
                            textAlign: 'center',
                            fontFamily: 'Poppins',
                            color: '#004894',
                            cursor: 'pointer',
                        }}
                    >
                        {LogoLinkProps.mfgText}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default LogoLink;
